/* Drawer-only redirect + cart-page whitelist (shadow-safe) */
(function () {
  var CART_URL = '/cart';
  var CHECKOUT_URL = '/checkout';
  var DRAWER_SELECTOR =
    '[data-recharge-cart-drawer], [data-cart-drawer], [data-rc-cart-drawer], .rc-cart-drawer, [data-drawer], [role="dialog"]';

  // handle /cart and /{locale}/cart
  function onCartPage() { return /\/cart(?:\/|$)/.test(location.pathname); }

  // native assign that ignores any previous monkey patches
  var nativeAssign = (Location && Location.prototype && Location.prototype.assign)
    ? Location.prototype.assign.bind(window.location)
    : function (url) { window.location = url; };

  function eventIsInDrawer(e) {
    var path = (typeof e.composedPath === 'function') ? e.composedPath() : [e.target];
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n && n.nodeType === 1) {
        if ((n.matches && n.matches(DRAWER_SELECTOR)) ||
            (n.closest && n.closest(DRAWER_SELECTOR))) return true;
      }
    }
    return false;
  }

  function isCheckoutNode(n) {
    if (!n || n.nodeType !== 1) return false;
    if ((n.tagName === 'BUTTON' || n.tagName === 'INPUT') && n.getAttribute('name') === 'checkout') return true;
    if (n.tagName === 'A' && /\/checkout/i.test(n.getAttribute('href') || '')) return true;
    if (n.tagName === 'FORM' && /\/checkout/i.test(n.getAttribute('action') || '')) return true;
    if (n.hasAttribute && (n.hasAttribute('data-rc-go-checkout') || n.hasAttribute('data-recharge-go-checkout'))) return true;
    var t = (n.textContent || '').trim().toLowerCase();
    return (t && /checkout/.test(t) && (n.tagName === 'BUTTON' || n.tagName === 'A'));
  }

  /* ---------- CART PAGE: allow checkout ---------- */
  function enableCartCheckout() {
    // On cart page, ensure clicking the checkout button actually goes to checkout
    var handler = function (e) {
      var path = (typeof e.composedPath === 'function') ? e.composedPath() : [e.target];
      var clickedCheckout = false, formInPath = null;

      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (!n || n.nodeType !== 1) continue;
        if ((n.tagName === 'BUTTON' || n.tagName === 'INPUT') && n.getAttribute('name') === 'checkout') {
          clickedCheckout = true;
        }
        if (!formInPath && n.tagName === 'FORM') formInPath = n;
      }

      // If a checkout control or a form containing it was used, force native navigation to /checkout
      if (clickedCheckout || (formInPath && formInPath.querySelector('[name="checkout"]'))) {
        e.preventDefault();
        e.stopImmediatePropagation();
        try {
          if (formInPath) { formInPath.removeAttribute('action'); } // avoid /cart loops
        } catch(_) {}
        nativeAssign(CHECKOUT_URL);
      }
    };

    // High-priority capture to beat any old interceptors
    document.addEventListener('click', handler, true);
    document.addEventListener('submit', handler, true);
  }

  if (onCartPage()) {
    enableCartCheckout();            // whitelist cart page
    return;                          // don't install drawer redirect on this page
  }

  /* ---------- DRAWER: force to /cart ---------- */
  document.addEventListener('click', function (e) {
    if (!eventIsInDrawer(e)) return;
    var path = (typeof e.composedPath === 'function') ? e.composedPath() : [e.target];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (isCheckoutNode(node)) {
        e.preventDefault();
        e.stopPropagation();
        try {
          var form = node.closest && node.closest('form');
          if (form) { form.action = CART_URL; form.method = 'get'; }
        } catch(_) {}
        nativeAssign(CART_URL);
        return false;
      }
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (!eventIsInDrawer(e)) return;
    var form = e.target;
    if (!form) return;
    if (isCheckoutNode(form) ||
        form.querySelector('button[name="checkout"], [data-rc-go-checkout], [data-recharge-go-checkout], a[href^="/checkout"]')) {
      e.preventDefault();
      e.stopPropagation();
      form.action = CART_URL; form.method = 'get';
      nativeAssign(CART_URL);
    }
  }, true);

  // Cosmetic: make the drawer button read "View cart"
  function relabelDrawer() {
    document.querySelectorAll(
      DRAWER_SELECTOR + ' button[name="checkout"], ' +
      DRAWER_SELECTOR + ' [name="checkout"][type="submit"], ' +
      DRAWER_SELECTOR + ' [data-rc-go-checkout], ' +
      DRAWER_SELECTOR + ' a[href^="/checkout"]'
    ).forEach(function (el) {
      try { el.textContent = 'View cart'; el.setAttribute('aria-label', 'View cart'); } catch(_){}
    });
  }
  document.addEventListener('DOMContentLoaded', relabelDrawer);
  document.addEventListener('recharge:cart-drawer:opened', relabelDrawer);
  document.addEventListener('recharge:cart:updated', relabelDrawer);

  // Small retry for late renders
  var tries = 0, iv = setInterval(function () {
    relabelDrawer();
    if (++tries > 20) clearInterval(iv);
  }, 500);
})();







/* ===== Essential Cart Updates for Recharge Integration ===== */
// Simple cart update system that works with Shopify's native cart bubble
(function () {
  // Listen for Recharge cart events and trigger Shopify's native cart updates
  function triggerCartUpdate() {
    // Fetch fresh cart data and update
    fetch('/cart.js', { 
      credentials: 'same-origin', 
      headers: { 'Accept': 'application/json' },
      cache: 'no-cache'
    })
    .then(r => r.json())
    .then(cart => {
      // Calculate total quantity of all items (not just unique items)
      let totalQuantity = 0;
      if (cart && cart.items) {
        totalQuantity = cart.items.reduce((sum, item) => sum + (item.quantity || 0), 0);
      }
      
      // Fallback to item_count if calculation fails
      const itemCount = totalQuantity > 0 ? totalQuantity : (cart?.item_count || 0);
      
      console.log('Cart data fetched:', { 
        itemCount, 
        totalQuantity,
        itemCountFromAPI: cart?.item_count,
        cartItems: cart?.items?.length,
        items: cart?.items?.map(item => ({ 
          title: item.title, 
          quantity: item.quantity,
          variant_id: item.variant_id,
          product_id: item.product_id
        })),
        cart: cart 
      });
      
      // Use the Shopify cart API count as the source of truth
      const finalCount = itemCount;
      
      // Only dispatch events if the count is actually changing
      const currentCount = window.lastKnownCartCount || 0;
      if (finalCount !== currentCount) {
        console.log('Cart count changed, updating instantly:', { from: currentCount, to: finalCount });
        
        // Update instantly - no updating state delay
        // Check if this is a product form submission with correct variant
        const isProductFormSubmission = window.lastCartUpdateSource === 'product-form';
        const source = isProductFormSubmission ? 'product-form' : 'recharge-cart';
        
        document.dispatchEvent(new CustomEvent('cart:update', {
          detail: {
            data: {
              itemCount: finalCount,
              source: source,
              comingFromProductForm: isProductFormSubmission
            }
          }
        }));
        window.lastKnownCartCount = finalCount;
      } else {
        console.log('Cart count unchanged, no event dispatched:', finalCount);
        // Don't dispatch any events if count hasn't changed
        window.lastKnownCartCount = finalCount;
      }
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
  }

  // Listen for Recharge events - but debounce to prevent multiple rapid updates
  let updateTimeout;
  function debouncedTriggerCartUpdate() {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(triggerCartUpdate, 100); // Very short delay just to batch rapid updates
  }

  // Listen for Recharge events
  ['recharge:cart:updated', 'recharge:cart:item-added', 'recharge:cart:item-removed', 'recharge:cart-drawer:opened'].forEach(eventName => {
    document.addEventListener(eventName, debouncedTriggerCartUpdate);
  });
  
  // Listen for native Shopify cart events
  ['cart:updated', 'cart:change', 'cart:refresh', 'cart:item-added', 'cart:item-removed'].forEach(eventName => {
    document.addEventListener(eventName, debouncedTriggerCartUpdate);
  });
  
  // Listen for custom theme events
  ['theme:cart:update', 'cart:update'].forEach(eventName => {
    document.addEventListener(eventName, debouncedTriggerCartUpdate);
  });

  // Listen for any clicks in Recharge drawer
  document.addEventListener('click', function(e) {
    // Check if click is in a Recharge drawer
    const drawerSelectors = '[data-recharge-cart-drawer], [data-cart-drawer], [data-rc-cart-drawer], .rc-cart-drawer, [role="dialog"]';
    const isInDrawer = e.target.closest && e.target.closest(drawerSelectors);
    
    // Also check for specific cart action buttons
    const isCartAction = e.target.matches && (
      e.target.matches('button[data-quantity]') ||
      e.target.matches('button[data-cart-item]') ||
      e.target.matches('[data-cart-remove]') ||
      e.target.matches('.cart-item-remove') ||
      e.target.matches('.remove-item') ||
      e.target.matches('button[aria-label*="remove"]') ||
      e.target.matches('button[aria-label*="delete"]') ||
      e.target.closest('[data-cart-item]') ||
      e.target.closest('.cart-item')
    );
    
    if (isInDrawer || isCartAction) {
      console.log('Cart action detected:', { 
        target: e.target, 
        isInDrawer, 
        isCartAction,
        className: e.target.className,
        dataset: e.target.dataset
      });
      // Small delay to let Recharge process the action first
      setTimeout(triggerCartUpdate, 300);
    }
  });

  // Also listen for form submissions that might add/remove items
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form && (form.action.includes('/cart/add') || form.action.includes('/cart/change'))) {
      console.log('Cart form submission detected:', form.action);
      setTimeout(triggerCartUpdate, 300);
    }
  });

  // Force refresh cart count on page load to ensure accuracy
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Page loaded - refreshing cart count');
    triggerCartUpdate();
    
    // Also try to directly update the cart bubble as a test
    setTimeout(() => {
      const cartBubbleText = document.querySelector('.cart-bubble__text-count, .cart-bubble__text');
      if (cartBubbleText) {
        console.log('Direct cart bubble update test - current text:', cartBubbleText.textContent);
        // Don't change it yet, just log what we see
      }
    }, 2000);
  });

  // Set up MutationObserver to watch for any cart-related changes globally
  function setupCartObserver() {
    console.log('Setting up global cart MutationObserver');
    
    let lastMutationTime = 0;
    const MUTATION_COOLDOWN = 200; // 200ms cooldown between mutations
    
    const observer = new MutationObserver(function(mutations) {
      const now = Date.now();
      if (now - lastMutationTime < MUTATION_COOLDOWN) {
        return; // Skip if too soon since last mutation
      }
      
      let shouldUpdate = false;
      
      mutations.forEach(function(mutation) {
        // Check if cart items were added/removed or quantities changed
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes);
          const removedNodes = Array.from(mutation.removedNodes);
          
          // Check if any cart-related elements were added/removed
          const hasCartChanges = addedNodes.some(node => 
            node.nodeType === 1 && (
              node.matches && (
                node.matches('[data-cart-item]') ||
                node.matches('.cart-item') ||
                node.matches('[class*="cart-item"]') ||
                node.matches('[class*="cart"]') ||
                node.matches('[data-cart]')
              ) || 
              node.querySelector && node.querySelector('[data-cart-item], .cart-item, [class*="cart-item"], [class*="cart"], [data-cart]')
            )
          ) || removedNodes.some(node => 
            node.nodeType === 1 && (
              node.matches && (
                node.matches('[data-cart-item]') ||
                node.matches('.cart-item') ||
                node.matches('[class*="cart-item"]') ||
                node.matches('[class*="cart"]') ||
                node.matches('[data-cart]')
              ) || 
              node.querySelector && node.querySelector('[data-cart-item], .cart-item, [class*="cart-item"], [class*="cart"], [data-cart]')
            )
          );
          
          if (hasCartChanges) {
            console.log('Cart changes detected via MutationObserver');
            shouldUpdate = true;
          }
        }
        
        // Check if text content changed (like quantity or subtotal)
        if (mutation.type === 'characterData' || mutation.type === 'childList') {
          const target = mutation.target;
          if (target && target.textContent && (
            target.textContent.includes('items') ||
            target.textContent.includes('Subtotal') ||
            target.textContent.includes('cart') ||
            target.textContent.includes('Cart')
          )) {
            console.log('Cart text content changed:', target.textContent);
            shouldUpdate = true;
          }
        }
      });
      
      if (shouldUpdate) {
        lastMutationTime = now;
        console.log('MutationObserver triggering cart update');
        debouncedTriggerCartUpdate();
      }
    });
    
    // Observe the entire document for cart changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    
    // Store observer for cleanup if needed
    window.cartObserver = observer;
  }

  // Also refresh after a short delay to catch any late-loading elements
  setTimeout(triggerCartUpdate, 1000);
  
  // Set up the observer after a delay to ensure cart drawer is loaded
  setTimeout(setupCartObserver, 2000);
  
  // No polling needed - cart updates should be event-driven
})();



